module.exports = __webpack_public_path__ + "img/招投标助手.8a8262f8.jpg";